<template>
  <section class="careers-culture locked">
    <div class="page-container careers-culture__inner relative">
      <h2 class="careers-culture__title">A&nbsp;winning culture takes powerful values</h2>
      <p class="careers-culture__subtitle">
        We're an ambitious, results-driven team living by six key core value that drive everything we do as an
        organization.
      </p>

      <ul class="careers-culture__cards grid-row justify-center">
        <li
          v-for="value in values"
          :key="value.color + value.title"
          class="flex col-4 pt0 pb2 justify-between careers-culture__card"
        >
          <BravadoCard :item="value" variant="sss">
            <template v-if="value.image" #text-image>
              <div class="careers-culture__card-image">
                <img :src="value.image" width="200" height="160" :alt="value.title" />
              </div>
            </template>
          </BravadoCard>
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import BravadoCard from '~/components/partials/landings/ui/BravadoItemCard.vue';
import { values } from '~/components/partials/landings/careers/constants';

export default Vue.extend({
  name: 'CareersCulture',
  components: { BravadoCard },
  data() {
    return {
      values,
    };
  },
});
</script>

<style lang="scss" scoped>
.careers-culture {
  padding: 0 18px 0;
  z-index: 1;

  @include mq('sm') {
    padding: 0 30px 0;
  }

  &__inner {
    padding: 0;

    @include mq('sm') {
      padding: 0 16px;
    }
  }

  @include mq('sm') {
    padding: 68px 0 0;
  }

  &__title {
    color: #161a21;
    max-width: 550px;
    margin: 0 0 16px;

    @include bravado-h4;

    @include mq('sm') {
      margin: 0 0 20px;

      @include bravado-h1;
    }
  }

  &__subtitle {
    color: #19191a;
    max-width: 630px;
    margin: 0 0 31px;

    @include body;

    @include mq('sm') {
      margin: 0 0 100px;

      @include bravado-super-headline;
    }
  }

  &__cards {
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: 14px;
    margin: 0 0 45px;
    padding-left: 0;

    .col-4 {
      flex: 0 0 50%;
      min-width: 50%;
      max-width: 50%;
    }

    @include mq('sm') {
      display: flex;
      grid-column-gap: 0;
      grid-row-gap: 0;
      min-width: 410px;
      margin: -16px -16px 45px;

      // .col-4 {
      //   flex: 0 0 calc(4 / 12 * 100%);
      //   min-width: calc(4 / 12 * 100%);
      //   max-width: calc(4 / 12 * 100%);
      //   margin-bottom: 70px;
      // }
    }

    ::v-deep .bravado-card {
      min-height: 268px;

      &__title {
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 82%;
        margin-right: auto;
        margin-left: auto;
      }

      &__subtitle {
        max-width: 95%;
        margin-right: auto;
        margin-left: auto;
      }
    }
  }

  &__card.col-4 {
    max-width: none;
    min-width: auto;
    padding: 0;

    @include mq('sm') {
      flex: 0 0 calc(4 / 12 * 100%);
      min-width: calc(4 / 12 * 100%);
      max-width: calc(4 / 12 * 100%);
      padding: 16px;
      margin-bottom: 70px;
      padding-top: 0;
    }

    .bravado-card--sss {
      min-width: auto;

      @include mq('sm') {
        min-width: 192px;
      }
    }

    ::v-deep .bravado-card__subtitle {
      line-height: 1.15;

      @include mq('sm') {
        line-height: 20px;
      }
    }
  }

  &__card-image {
    height: 100px;
    width: 100px;
    margin: 12px auto 22px;

    img {
      width: 100%;
      height: auto;
    }

    @include mq('sm') {
      height: 200px;
      width: 200px;
      margin: 0 auto 6px;
    }
  }
}
</style>
